import React from 'react'
import { Button, Flex, Heading, Modal, Text } from '@workwhile/ui'
import { useDeleteRateConfirmFlowContextValue } from '../context/DeleteRateConfirmFlowProvider'
import { useRuleDetailWorkflowsContextValue } from '../../../context/RuleDetailWorkflowsProvider'
import { formatNumberToCurrency } from 'lib/number'

export const DeleteRateConfirmFlowMain = () => {
  const { deleteRateConfirmFlow } = useRuleDetailWorkflowsContextValue()
  const { isOpen, selectedRate, close } = deleteRateConfirmFlow

  const {
    state: { isPending },
    actions: { confirm },
  } = useDeleteRateConfirmFlowContextValue()

  return (
    <Modal
      open={isOpen}
      onClose={close}
      position="top"
      loading={isPending}
      customCta={
        <Flex>
          <Button variant="text" onClick={close}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={confirm}>
            Delete
          </Button>
        </Flex>
      }
    >
      <Heading level={3} fontWeight="400" style={{ margin: 0 }}>
        Delete rate
      </Heading>
      <Text mt={3}>
        Are you sure you want to delete the{' '}
        {selectedRate
          ? formatNumberToCurrency(selectedRate.hourlyRateCents / 100)
          : 'selected'}{' '}
        rate? This action cannot be undone.
      </Text>
    </Modal>
  )
}
